module.exports = __webpack_public_path__ + "media/media/home/img3-3996b1408bb5d26d7cdc17abf36da6bd.png";